module.exports = __webpack_public_path__ + "42bf3712f4dcec2b86436ab00df8f4a9.png";